import cidacosDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/cidacos-desktop.webp'
import cidacosFallbackPng from '../../../../assets/OurSuppliersSectionAssets/cidacos-fallback.png'
import cidacosMobileWebp from '../../../../assets/OurSuppliersSectionAssets/cidacos-mobile.webp'
import dunbiaDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/dunbia-desktop.webp'
import dunbiaFallbackPng from '../../../../assets/OurSuppliersSectionAssets/dunbia-fallback.png'
import dunbiaMobileWebp from '../../../../assets/OurSuppliersSectionAssets/dunbia-mobile.webp'
import jollyHogDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-desktop.webp'
import jollyHogFallbackPng from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-fallback.png'
import jollyHogMobileWebp from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-mobile.webp'
import tofooDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/tofoo-desktop.webp'
import tofooFallbackPng from '../../../../assets/OurSuppliersSectionAssets/tofoo-fallback.png'
import tofooMobileWebp from '../../../../assets/OurSuppliersSectionAssets/tofoo-mobile.webp'
import yeoValleyDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-desktop.webp'
import yeoValleyFallbackPng from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-fallback.png'
import yeoValleyMobileWebp from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-mobile.webp'

export const supplierCardProps = [
  {
    webpSmall: yeoValleyMobileWebp,
    webpLarge: yeoValleyDesktopWebp,
    fallback: yeoValleyFallbackPng,
    alt: 'Yeo Valley Organic supplier card',
    supplierDetails: {
      title: 'Yeo Valley Organic',
      location: 'Somerset, UK',
      since: 'Supplier since 2018',
      tag: 'Organic Farming',
    },
  },
  {
    webpSmall: tofooMobileWebp,
    webpLarge: tofooDesktopWebp,
    fallback: tofooFallbackPng,
    alt: 'ToFoo supplier card',
    supplierDetails: {
      title: 'ToFoo',
      location: 'Yorkshire, UK',
      since: 'Supplier since 2018',
      tag: 'Soil Association Organic',
    },
  },
  {
    webpSmall: jollyHogMobileWebp,
    webpLarge: jollyHogDesktopWebp,
    fallback: jollyHogFallbackPng,
    alt: 'Jolly Hog supplier card',
    supplierDetails: {
      title: 'Jolly Hog',
      location: 'Bristol, UK',
      since: 'Supplier since 2021',
      tag: 'B Corp | Great Taste',
    },
  },
  {
    webpSmall: cidacosMobileWebp,
    webpLarge: cidacosDesktopWebp,
    fallback: cidacosFallbackPng,
    alt: 'Cidacos supplier card',
    supplierDetails: {
      title: 'Cidacos',
      location: 'Toledo, Spain',
      since: 'Supplier since 2019',
      tag: undefined,
    },
  },
  {
    webpSmall: dunbiaMobileWebp,
    webpLarge: dunbiaDesktopWebp,
    fallback: dunbiaFallbackPng,
    alt: 'Dunbia supplier card',
    supplierDetails: {
      title: 'Dunbia',
      location: 'Cross Hands, UK',
      since: 'Supplier since 2024',
      tag: undefined,
    },
  },
]
